
const libPictView = require('pict-view');

class CustomerProvisioning extends libPictView
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/** @type {any} */
		this.pict;
	}

	/**
	 * Recompute every derived render slot from the current AppData state.
	 *
	 * All template-facing arrays/flags live on AppData.CustomerProvisioning so the
	 * template repaints declaratively after any provider mutation + render().
	 */
	deriveRenderState()
	{
		let tmpProvider = this.pict.providers.CustomerProvisioningProvider;

		if (!this.pict.AppData.CustomerProvisioning)
		{
			tmpProvider.initializeState();
		}

		tmpProvider.deriveStepState();
		tmpProvider.deriveDatasetRows();
		tmpProvider.derivePersonaGroups();
		tmpProvider.deriveRoleRows();
		tmpProvider.deriveReviewState();
		tmpProvider.derivePushState();
	}

	onBeforeRender(pRenderable)
	{
		this.deriveRenderState();
		return super.onBeforeRender(pRenderable);
	}

	onBeforeRenderAsync(fCallback)
	{
		this.deriveRenderState();
		return fCallback();
	}

	onAfterRender(pRenderable, pAddress, pRecord, pContent)
	{
		this.pict.CSSMap.injectCSS();
		return super.onAfterRender(pRenderable, pAddress, pRecord, pContent);
	}
}

module.exports = CustomerProvisioning;

module.exports.default_configuration =
{
	ViewIdentifier: 'CustomerProvisioning',
	DefaultRenderable: 'CustomerProvisioningWrap',
	DefaultDestinationAddress: '#PlatformConfiguration-Application-Container',
	AutoRender: false,
	Templates:
	[
		{
			Hash: 'CustomerProvisioning-DatasetRow',
			Template: /*html*/`
				<tr class="cp-dataset-row {~D:Record.RowClass~}">
					<td><strong>{~D:Record.Code~}</strong></td>
					<td>{~D:Record.Name~}</td>
					<td class="has-text-right">{~D:Record.Records~}</td>
					<td class="has-text-right">{~D:Record.TestForms~}</td>
					<td class="has-text-right">{~D:Record.TestProcedures~}</td>
					<td class="has-text-right">{~D:Record.ExampleProjects~}</td>
					<td class="has-text-right">{~D:Record.BidTabs~}</td>
					<td>
						<button class="button is-small is-info is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.selectDataset('{~D:Record.Code~}')">
							Select
						</button>
					</td>
				</tr>`,
		},
		{
			Hash: 'CustomerProvisioning-DatasetSummary',
			Template: /*html*/`
				<div class="notification is-info is-soft mt-4">
					<strong>{~D:Record.Name~} ({~D:Record.Code~})</strong> selected.
					{~D:Record.Records~} entity records, {~D:Record.ExampleProjects~} example projects, ~183 forms.
					<button class="button is-info is-small ml-4" onclick="_Pict.providers.CustomerProvisioningProvider.completeStep(1)">
						Continue <i class="fas fa-arrow-right ml-2"></i>
					</button>
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-PersonaUser',
			Template: /*html*/`
				<div class="column is-4">
					<label class="checkbox">
						<input type="checkbox" {~D:Record.CheckedAttr~} onchange="_Pict.providers.CustomerProvisioningProvider.togglePersona({~D:Record.Index~})" />
						<strong>{~D:Record.NameFirst~} {~D:Record.NameLast~}</strong>
						<br /><small class="has-text-grey">{~D:Record.Title~}</small>
					</label>
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-PersonaGroup',
			Template: /*html*/`
				<h6 class="title is-6 mt-3">{~D:Record.Category~}</h6>
				<div class="columns is-multiline">
					{~TS:CustomerProvisioning-PersonaUser:Record.Users~}
				</div>`,
		},
		{
			Hash: 'CustomerProvisioning-RoleRow',
			Template: /*html*/`
				<tr>
					<td>{~D:Record.Name~}</td>
					<td><code>{~D:Record.Code~}</code></td>
					<td><span class="tag">{~D:Record.Type~}</span></td>
				</tr>`,
		},
		{
			Hash: 'CustomerProvisioning-LogLine',
			Template: /*html*/`<div>{~D:Record.Display~}</div>`,
		},
		{
			Hash: 'CustomerProvisioningWrap',
			Template: /*html*/`
			<section class="section">
				<div class="container">
					<div class="mb-5">
						<h1 class="title is-3">
							<span class="icon"><i class="fas fa-wand-magic-sparkles"></i></span>
							&nbsp;Customer Provisioning
						</h1>
						<p class="subtitle is-5 has-text-grey">
							Create a complete new customer environment from a specifications library dataset
						</p>
					</div>

					<!-- Step 1: Dataset Selection -->
					<article class="message is-info mb-4" id="CP-Step1">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(1)">
							<p><span class="icon"><i class="fas fa-database"></i></span>&nbsp;Step 1: Select Dataset</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step1_StatusClass~}">{~D:AppData.CustomerProvisioning.Step1_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step1_BodyClass~}">
							<div class="field mb-4">
								<div class="control has-icons-left">
									<input class="input" type="text" placeholder="Filter by state name or code..."
										value="{~D:AppData.CustomerProvisioning.DatasetFilter~}"
										oninput="_Pict.providers.CustomerProvisioningProvider.filterDatasetTable(this.value)" />
									<span class="icon is-left"><i class="fas fa-search"></i></span>
								</div>
							</div>
							<div class="table-container">
								<table class="table is-fullwidth is-hoverable is-striped">
									<thead>
										<tr>
											<th>Code</th>
											<th>State</th>
											<th class="has-text-right">Records</th>
											<th class="has-text-right">Test Forms</th>
											<th class="has-text-right">Test Procedures</th>
											<th class="has-text-right">Example Projects</th>
											<th class="has-text-right">Bid Tabs</th>
											<th></th>
										</tr>
									</thead>
									<tbody id="CP-Dataset-Rows">
										{~TS:CustomerProvisioning-DatasetRow:AppData.CustomerProvisioning.DatasetRows~}
									</tbody>
								</table>
							</div>
							{~TS:CustomerProvisioning-DatasetSummary:AppData.CustomerProvisioning.DatasetSummarySlot~}
						</div>
					</article>

					<!-- Step 2: Customer Details -->
					<article class="message mb-4" id="CP-Step2">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(2)">
							<p><span class="icon"><i class="fas fa-building"></i></span>&nbsp;Step 2: Customer Details</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step2_StatusClass~}">{~D:AppData.CustomerProvisioning.Step2_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step2_BodyClass~}">
							<!-- Customer form -->
							<div class="columns">
								<div class="column is-6">
									<div class="field">
										<label class="label">Customer Name</label>
										<div class="control"><input class="input" type="text" id="CP-CustomerName" placeholder="e.g., Alabama DOT" value="{~D:AppData.CustomerProvisioning.Customer.Name~}" /></div>
									</div>
								</div>
								<div class="column is-3">
									<div class="field">
										<label class="label">Customer Code</label>
										<div class="control"><input class="input" type="text" id="CP-CustomerCode" placeholder="e.g., ALDOT-DEMO" maxlength="12" value="{~D:AppData.CustomerProvisioning.Customer.Code~}" /></div>
										<p class="help">Max 12 characters, used for GUIDs</p>
									</div>
								</div>
								<div class="column is-3">
									<div class="field">
										<label class="label">Timezone</label>
										<div class="control">
											<div class="select is-fullwidth">
												<select id="CP-Timezone">
													<option value="America/New_York">Eastern</option>
													<option value="America/Chicago">Central</option>
													<option value="America/Denver">Mountain</option>
													<option value="America/Los_Angeles">Pacific</option>
													<option value="America/Anchorage">Alaska</option>
													<option value="Pacific/Honolulu">Hawaii</option>
												</select>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveCustomerConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 3: User Accounts -->
					<article class="message mb-4" id="CP-Step3">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(3)">
							<p><span class="icon"><i class="fas fa-users"></i></span>&nbsp;Step 3: User Accounts</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step3_StatusClass~}">{~D:AppData.CustomerProvisioning.Step3_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step3_BodyClass~}">
							<!-- Admin User -->
							<h5 class="title is-5">Administrator Account</h5>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">First Name</label>
										<div class="control"><input class="input" type="text" id="CP-AdminFirst" value="{~D:AppData.CustomerProvisioning.AdminUser.NameFirst~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Last Name</label>
										<div class="control"><input class="input" type="text" id="CP-AdminLast" value="{~D:AppData.CustomerProvisioning.AdminUser.NameLast~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Email</label>
										<div class="control"><input class="input" type="email" id="CP-AdminEmail" value="{~D:AppData.CustomerProvisioning.AdminUser.Email~}" /></div>
									</div>
								</div>
							</div>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">Login ID</label>
										<div class="control"><input class="input" type="text" id="CP-AdminLogin" value="{~D:AppData.CustomerProvisioning.AdminUser.LoginID~}" /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Password</label>
										<div class="control"><input class="input" type="text" id="CP-AdminPassword" value="{~D:AppData.CustomerProvisioning.AdminUser.LoginPassword~}" /></div>
									</div>
								</div>
							</div>

							<hr />
							<h5 class="title is-5">Integration Service Account</h5>
							<p class="has-text-grey mb-3">Auto-generated from customer code. Used for data import operations.</p>
							<div class="columns">
								<div class="column is-4">
									<div class="field"><label class="label">Login ID</label>
										<div class="control"><input class="input" type="text" id="CP-IntegrationLogin" value="{~D:AppData.CustomerProvisioning.IntegrationUser.LoginID~}" readonly /></div>
									</div>
								</div>
								<div class="column is-4">
									<div class="field"><label class="label">Password</label>
										<div class="control"><input class="input" type="text" id="CP-IntegrationPassword" value="{~D:AppData.CustomerProvisioning.IntegrationUser.LoginPassword~}" /></div>
									</div>
								</div>
							</div>

							<hr />
							<h5 class="title is-5">Example User Accounts</h5>
							<p class="has-text-grey mb-3">Based on HeadLight personas. Uncheck any you don't want to create.</p>
							<div id="CP-PersonaList">
								{~TS:CustomerProvisioning-PersonaGroup:AppData.CustomerProvisioning.PersonaGroups~}
							</div>

							<div class="field is-grouped is-grouped-right mt-4">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveUserConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 4: Security & Defaults -->
					<article class="message mb-4" id="CP-Step4">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(4)">
							<p><span class="icon"><i class="fas fa-shield-halved"></i></span>&nbsp;Step 4: Security & Configuration</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step4_StatusClass~}">{~D:AppData.CustomerProvisioning.Step4_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step4_BodyClass~}">
							<h5 class="title is-5">Roles to Create</h5>
							<table class="table is-fullwidth is-striped">
								<thead><tr><th>Role</th><th>Code</th><th>Type</th></tr></thead>
								<tbody>
									{~TS:CustomerProvisioning-RoleRow:AppData.CustomerProvisioning.RoleRows~}
								</tbody>
							</table>
							<hr />
							<div class="field is-grouped is-grouped-right">
								<div class="control">
									<button class="button is-info" onclick="_Pict.providers.CustomerProvisioningProvider.saveSecurityConfig()">
										<span class="icon"><i class="fas fa-arrow-right"></i></span><span>Continue</span>
									</button>
								</div>
							</div>
						</div>
					</article>

					<!-- Step 5: Review & Generate -->
					<article class="message is-success mb-4" id="CP-Step5">
						<div class="message-header" style="cursor:pointer"
							onclick="_Pict.providers.CustomerProvisioningProvider.goToStep(5)">
							<p><span class="icon"><i class="fas fa-rocket"></i></span>&nbsp;Step 5: Review & Generate</p>
							<span class="tag {~D:AppData.CustomerProvisioning.Step5_StatusClass~}">{~D:AppData.CustomerProvisioning.Step5_StatusLabel~}</span>
						</div>
						<div class="message-body {~D:AppData.CustomerProvisioning.Step5_BodyClass~}">
							<table class="table is-fullwidth is-striped">
								<tbody>
									<tr><td><strong>Customer</strong></td><td>{~D:AppData.CustomerProvisioning.CustomerLabel~}</td></tr>
									<tr><td><strong>Admin User</strong></td><td>{~D:AppData.CustomerProvisioning.AdminLabel~}</td></tr>
									<tr><td><strong>Example Personas</strong></td><td>{~D:AppData.CustomerProvisioning.PersonaSelectedCount~} selected</td></tr>
									<tr><td><strong>Dataset</strong></td><td>{~D:AppData.CustomerProvisioning.DatasetLabel~}</td></tr>
									<tr><td><strong>Spec Records</strong></td><td>{~D:AppData.CustomerProvisioning.SpecRecords~}</td></tr>
									<tr><td><strong>Roles</strong></td><td>{~D:AppData.CustomerProvisioning.RoleCount~} roles</td></tr>
								</tbody>
							</table>
							<hr />
							<div class="buttons is-right">
								<button class="button is-link is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.downloadComprehension(1)">
									<span class="icon"><i class="fas fa-download"></i></span><span>Download Phase 1 (Customer Setup)</span>
								</button>
								<button class="button is-link is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.downloadComprehension(2)">
									<span class="icon"><i class="fas fa-download"></i></span><span>Download Phase 2 (Spec Data)</span>
								</button>
								<button class="button is-primary" onclick="_Pict.providers.CustomerProvisioningProvider.createRequestDocument()">
									<span class="icon"><i class="fas fa-file-circle-plus"></i></span><span>Submit as New Customer Request</span>
								</button>
								<button class="button is-success is-outlined" onclick="_Pict.providers.CustomerProvisioningProvider.pushToHeadLight()" title="Provision immediately, skipping the approval request">
									<span class="icon"><i class="fas fa-cloud-arrow-up"></i></span><span>Push to HeadLight</span>
								</button>
							</div>
							<!-- Progress panel (shown during push) -->
							<div id="CP-PushProgress" class="box mt-4 {~D:AppData.CustomerProvisioning.PushState.PanelClass~}">
								<h5 class="title is-5">Push Progress</h5>
								<progress class="progress is-info" value="{~D:AppData.CustomerProvisioning.PushState.Progress~}" max="100">{~D:AppData.CustomerProvisioning.PushState.Progress~}%</progress>
								<p class="has-text-grey">{~D:AppData.CustomerProvisioning.PushState.StatusText~}</p>
								<div class="content" style="max-height:300px;overflow-y:auto;font-family:monospace;font-size:0.85em;">
									{~TS:CustomerProvisioning-LogLine:AppData.CustomerProvisioning.PushState.Log~}
								</div>
							</div>
						</div>
					</article>
				</div>
			</section>`,
		},
	],
	Renderables:
	[
		{
			RenderableHash: 'CustomerProvisioningWrap',
			TemplateHash: 'CustomerProvisioningWrap',
			DestinationAddress: '#PlatformConfiguration-Application-Container',
		},
	],
};
